import { useCallback } from 'react'
import { useSoeiStakingContract } from './useContract'

export const useCalculateSwapOutput = () => {
  const contractMethod = useSoeiStakingContract()

  const getData = useCallback(
    async (tokenName: string, amount: string) => {
      if (contractMethod) {
        let methodName = 'convertToSoi'
        if (tokenName === 'SOI') methodName = 'convertToUsd'

        return contractMethod[methodName](toLocaleString(amount))
      }
      return null
    },
    [contractMethod],
  )

  return getData
}

function toLocaleString(x) {
  return x.toLocaleString('fullwide', { useGrouping: false })
}
